<div class="container-login">
  <!-- LOGO del progetto -->
  <div class="logo-login">
    <a href="https://workinc.vtserver.eu/" target="_blank">
      <img src="img/logo_white.png" [attr.alt]="'auth.logo-alt' | translate" />
    </a>
  </div>

  <div class="login-box">
    <h2>{{ 'auth.login.title' | translate }}</h2>

    <form #loginForm="ngForm" (ngSubmit)="login(loginForm)" class="form-login">
      <app-alert-message [iconStyle]="{ top: '0rem', right: '0rem' }"></app-alert-message>

      <label for="email">{{ 'auth.fields.email' | translate }}</label>
      <input type="email" id="email" name="email" [(ngModel)]="email" required placeholder="{{ 'auth.placeholders.email' | translate }}"  />

      @if (!showPassword) {
        <label for="password">{{ 'auth.fields.password' | translate }}</label>
        <input type="password" id="password" name="password" [(ngModel)]="password" required placeholder="{{ 'auth.placeholders.password' | translate }}"  />
      }
      @else {
        <label for="password">{{ 'auth.fields.password' | translate }}</label>
        <input type="text" id="password" name="password" [(ngModel)]="password" required placeholder="{{ 'auth.placeholders.password' | translate }}"  />
      }

      <div class="show-password">
        <mat-checkbox (change)="showPassword=!showPassword"></mat-checkbox><a>{{ 'auth.show-password' | translate }}</a>
      </div>

      <button type="submit" class="btn-signin">{{ 'auth.login.sign-in' | translate }}</button>

      <!-- Forgot Password Button -->
      <button type="button" class="btn-forgot-password" routerLink="/forgot-password">
        <mat-icon>lock_reset</mat-icon>
        <span>{{ 'auth.login.forgot-password' | translate }}</span>
      </button>

      <!-- Additional Links -->
      <div class="login-links">
        <a routerLink="/registration" class="link-register">
          <mat-icon>person_add</mat-icon>
          <span>{{ 'auth.login.new-user-register' | translate }}</span>
        </a>
        <a routerLink="/resend-verification" class="link-verify">
          <mat-icon>mark_email_unread</mat-icon>
          <span>{{ 'auth.login.verify-email' | translate }}</span>
        </a>
      </div>
    </form>
  </div>
</div>
